<script>
import { Bar, mixins  } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'RebufChart',
  extends: Bar,
  mixins: [reactiveProp],
  data: function() {
    return {
      options:{
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                    if (tooltipItem.datasetIndex === 2) {
                        return tooltipItem.yLabel + ' %';
                    } else {
                    let label = data.datasets[tooltipItem.datasetIndex].label || '';
                    let value = tooltipItem.yLabel;
                    let unit = 's';
                    if (label) {
                        label += ': ';
                    }
                    if (value >= 3600) {
                      unit = 'H';
                      value = Math.round(value / 3600 * 10) / 10
                    } else if(value >= 60) {
                      unit = 'min';
                      value = Math.round(value / 60 * 10) / 10
                    }

                    label += value + ' ' + unit;
                    return label;
                    }
                    
                }
            }
        },
        scales: {
            xAxes: [{
                type: 'time',
                time: {
                  displayFormats:{
                    hour: 'DD/MM - H:mm',
                  },
                },
                distribution: 'series',
                stacked: true
            }],
            yAxes: [{
                id: 'A',
                stacked: true,
                ticks: {
                  min: 0,
                    callback: function(inputValue, index, values) {
                      let label = '';
                      let value = inputValue;
                      let unit = 's';
                        if (label) {
                            label += ': ';
                        }
                        if (value >= 3600) {
                            unit = 'H';
                            value = Math.round(value / 3600 * 10) / 10
                        } else if(value >= 60) {
                            unit = 'min';
                            value = Math.round(value / 60 * 10) / 10
                        }

                        label += value + ' ' + unit;
                        return label;
                    }
                }
            },{
                id: 'B',
                type: 'linear',
                position: 'right',
                ticks: {
                    min: 0,
                    max: 100,
                    callback: function(inputValue, index, values) {
                        let label = '';
                        let value = inputValue;
                        let unit = '%';
                        label += value + ' ' + unit;
                        return label;
                    }
                }
            }]
        },
        plugins: {
          datalabels: false,
          labels: false
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style>
</style>